<script lang="ts">
  import Button, { type ButtonProps } from "@elements/Button.svelte";

  export let buttons: ButtonProps[];
  export let position: "center" | "start" | "end" = "center";
  export let className: string = "";
  const positionClasses = {
    center: "md:justify-center",
    start: "md:justify-start",
    end: "md:justify-end",
  };

  export let flexClasses = "flex-col md:flex-row";
</script>

<div
  class={`mt-6 flex gap-3 ${flexClasses} justify-center ${positionClasses[position]} ${className ? className : ""}`}
>
  {#each buttons ?? [] as button}
    <Button {...button} />
  {/each}
</div>
